import AddCustomGiftCardButton from '../components/AddCustomGiftCard/AddCustomGiftCardButton';
import AddDigitalProductButton from '../components/AddDigitalProduct/AddDigitalProductButton';
import AddMinimumQuantityProductButton from '../components/AddMinimumQuantityProduct/AddMinimumQuantityProductButton';
import AddProductButton from '../components/AddProduct/AddProductButton';
import MedicalReadMoreButton from '../components/MedicalReadMore/MedicalReadMoreButton';
import FindInStoreButton from '../components/OpenFindInStore/FindInStoreButton';
import PreorderButton from '../components/OpenPreorder/PreorderButton';
import StockNotificationButton from '../components/OpenStockNotification/StockNotificationButton';
import WriteReviewButton from '../components/OpenWriteReview/WriteReviewButton';
import ReadMoreButton from '../components/ReadMore/ReadMoreButton';
import SoldOutButton from '../components/SoldOutProduct/SoldOutButton';
import SubscriptionProductButton from '../components/SubscriptionProduct/SubscriptionProductButton';
import VariantPickerButton from '../components/VariantPicker';
import { DefaultProductActionComponents, IProductActionButton } from './types';

/* Default - if new action is introduced in the backend, this will warn you that u need to support the action. */
const defaultActionComponents: DefaultProductActionComponents = {
    BuyNow: AddProductButton,
    BuyMinimumNow: AddMinimumQuantityProductButton,
    BuyNowDigitalProduct: AddDigitalProductButton,
    CustomizeProduct: AddCustomGiftCardButton,
    BackInStockNotification: StockNotificationButton,
    FindInStore: FindInStoreButton,
    WriteReview: WriteReviewButton,
    Preorder: PreorderButton,
    Favorite: ReadMoreButton,
    MedicalReadMore: MedicalReadMoreButton,
    More: ReadMoreButton,
    ReadMore: ReadMoreButton,
    SoldOut: SoldOutButton,
    Subscribe: SubscriptionProductButton,
    VariantPicker: VariantPickerButton
};

/* Compact - this is an override, so these are all optional and will be merged with the defaults above. */
export const compactActionComponents: IProductActionButton['overriddenActionComponents'] = {
    BuyNow: AddProductButton.Compact,
    BuyMinimumNow: AddMinimumQuantityProductButton.Compact,
    BuyNowDigitalProduct: AddDigitalProductButton.Compact,
    CustomizeProduct: AddCustomGiftCardButton.Compact,
    BackInStockNotification: StockNotificationButton.Compact,
    FindInStore: FindInStoreButton.Compact,
    WriteReview: WriteReviewButton.Compact,
    Preorder: PreorderButton.Compact,
    Favorite: ReadMoreButton.Compact,
    More: ReadMoreButton.Compact,
    ReadMore: ReadMoreButton.Compact,
    MedicalReadMore: MedicalReadMoreButton.Compact,
    SoldOut: SoldOutButton.Compact,
    Subscribe: SubscriptionProductButton.Compact,
    VariantPicker: VariantPickerButton.Compact
};

export default defaultActionComponents;
